import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  coverImage: string;
  publishedAt: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  categoryName,
  coverImage,
  publishedAt,
  readTime,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block no-underline">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-3 mb-3">
            <span className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
              {categoryName}
            </span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">{publishedAt}</span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">{readTime}阅读</span>
          </div>
          <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
            {excerpt}
          </p>
          <div className="flex items-center gap-2 flex-wrap">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="text-xs px-2 py-0.5 rounded bg-background-100 text-foreground-500 whitespace-nowrap"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </article>
  );
}